export default {
  fillFlow({ commit }, flow) {
    let formattedVisitFlow = {}
    formattedVisitFlow.title = flow.description
    formattedVisitFlow.icon= flow.icon
    formattedVisitFlow.flow= flow.names

    commit("updateFlow", formattedVisitFlow)
  },
}